import Img_flag_BL from "assets/images/flag/flag_BL.png";
import Img_flag_EN from "assets/images/flag/flag_EN.webp";
export const dataLanguage = [
  {
    id: "en",
    name: "English",
    img: Img_flag_EN
  },
  // {
  //   id: "zhS",
  //   name: "繁體中文",
  //   img: Img_flag_ZH
  // },
  {
    id: "bn",
    name: "বাংলা",
    img: Img_flag_BL
  }
];

export const dataSyslang = {
  en: 1,
  bn: 13
};

export const SYSLANG = "syslang";
export const I18NEXTLNG = "i18nextLng";
